/**
 * foodPhotography — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const foodPhotographyPack: ToilePack = {
    slug: 'food-photography',
    category: 'food',
    name: 'Food photography',
    tagline: tagline('plates', 'dishes', 'styles'),
    chips: chips('dishes', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'ramen', label: 'Ramen', subject: 'a bowl of tonkotsu ramen, a soft egg, chashu and nori'},
        {key: 'tart', label: 'Apple tart', subject: 'a rustic apple tart, lattice crust, vanilla ice cream'},
        {key: 'salad', label: 'Summer salad', subject: 'a bright salad, heirloom tomatoes, burrata and basil'},
    ],
    styles: [
        {key: 'overhead', label: 'Overhead', style: 'overhead flat-lay on linen', palette: 'soft daylight', framing: 'scattered ingredients'},
        {key: 'dark', label: 'Dark & moody', style: 'dark moody styling on slate', palette: 'low side light, deep shadows', framing: 'a single fork'},
        {key: 'menu', label: 'Menu shot', style: 'clean menu-style shot, white plate', palette: 'white background, studio light', framing: '45-degree angle'},
    ],
    directions: ['a breakfast spread instead', 'in warm autumn tones', 'with hands in the frame'],
}
